import { Button } from "@kamae-apps/shared/Components/Atoms/Button/Button"
import { NewsBar } from "@kamae-apps/shared/Components/Molecules/NewsBar/NewsBar"
import { useIsPageScrolling } from "@kamae-apps/shared/Hooks/useIsPageScrolling"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { SidebarMode, useSidebarMode } from "../../Contexts/SidebarMode/SidebarModeContext"
import { CURRENT_SPECIAL_EVENT_SEASON, SPECIAL_EVENT_SEASON, SPECIAL_EVENT_TEXT_COLOR } from "../../Types/SpecialEvent"

const SPECIAL_EVENT_BANNERS_BACKGROUND: Record<SPECIAL_EVENT_SEASON, string> = {
  [SPECIAL_EVENT_SEASON.WINTER]: "linear-gradient(90deg, #02285A 25%, #3A69A6 50%, #02285A 75%)",
  [SPECIAL_EVENT_SEASON.SPRING]: "linear-gradient(90deg, #FFCDE1 15%, #EED7E0 50%, #FFCDE1 85%)",
  [SPECIAL_EVENT_SEASON.SUMMER]: "linear-gradient(90deg, #D0E7FF 15%, #FFF7EF 50%, #FFDCBC 85%)",
  [SPECIAL_EVENT_SEASON.AUTUMN]: "var(--color-gradient-cybermois)",
}

const BANNER_BACKGROUND_STYLE_VARIANTS: Record<SPECIAL_EVENT_SEASON, SPECIAL_EVENT_TEXT_COLOR> = {
  [SPECIAL_EVENT_SEASON.WINTER]: SPECIAL_EVENT_TEXT_COLOR.LIGHT,
  [SPECIAL_EVENT_SEASON.SPRING]: SPECIAL_EVENT_TEXT_COLOR.DARK,
  [SPECIAL_EVENT_SEASON.SUMMER]: SPECIAL_EVENT_TEXT_COLOR.DARK,
  [SPECIAL_EVENT_SEASON.AUTUMN]: SPECIAL_EVENT_TEXT_COLOR.LIGHT,
}

export const NewsBarHandler: FC = () => {
  const { t } = useTranslation("app")
  const { isPageScrolling } = useIsPageScrolling()
  const { mode } = useSidebarMode()
  const navigate = useNavigate()
  const currentBackground = SPECIAL_EVENT_BANNERS_BACKGROUND[CURRENT_SPECIAL_EVENT_SEASON]

  const isLight = BANNER_BACKGROUND_STYLE_VARIANTS[CURRENT_SPECIAL_EVENT_SEASON] === SPECIAL_EVENT_TEXT_COLOR.LIGHT

  return (
    <div
      className={mode !== SidebarMode.MOBILE ? "mx-3 mt-3" : "mx-4 mt-3"}
      style={{
        transform: isPageScrolling ? "translateY(-100%)" : "translateY(0)",
        transition: "transform 0.3s ease-out",
        position: "relative",
      }}
    >
      <NewsBar
        title={t("app:newsBarModal.title")}
        primaryButton={
          <Button
            variant={isLight ? "button-secondary-glass-small" : "button-secondary-light-small"}
            onClick={() => navigate("/tatami#special-events")}
          >
            {t("app:newsBarModal.primaryButton")}
          </Button>
        }
        background={currentBackground}
        textColor={isLight ? "text-neutral-white" : "text-neutral-gray-600"}
        fullWidth
      />
    </div>
  )
}
